var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 129,
    viewBox: "0 0 156 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_950_980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 104.5C13.2495 98.4957 9.68243 57.2854 9.24416 52.2118C9.21455 51.8691 9.19634 51.5271 9.2109 51.1834C9.48149 44.7956 14.7457 39.7 21.2 39.7L134.8 39.7C141.254 39.7 146.518 44.7956 146.789 51.1834C146.804 51.5271 146.785 51.8691 146.756 52.2118C146.317 57.2852 142.751 98.4957 142 104.5C141.2 110.9 136.627 116.5 130 116.5H26C19.3726 116.5 14.8 110.9 14 104.5Z",
    fill: "#73D0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 104.5C13.2495 98.4957 9.68243 57.2854 9.24416 52.2118C9.21455 51.8691 9.19634 51.5271 9.2109 51.1834C9.48149 44.7956 14.7457 39.7 21.2 39.7L134.8 39.7C141.254 39.7 146.518 44.7956 146.789 51.1834C146.804 51.5271 146.785 51.8691 146.756 52.2118C146.317 57.2852 142.751 98.4957 142 104.5C141.2 110.9 136.627 116.5 130 116.5H26C19.3726 116.5 14.8 110.9 14 104.5Z",
    fill: "url(#paint0_radial_950_980)",
    fillOpacity: 0.16
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_950_980",
    x: 9.20578,
    y: 31.7,
    width: 137.588,
    height: 84.7998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.321569 0 0 0 0 0.686275 0 0 0 0 0.878431 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_950_980"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_950_980",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78 52.5) rotate(90) scale(48 76.8002)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFront);
export default __webpack_public_path__ + "static/media/folder-front.57a7ae36f89f07781d42204de73d88e4.svg";
export { ForwardRef as ReactComponent };